import avatar1 from '../../../assets/about/creators/1.jpg';
import avatar10 from '../../../assets/about/creators/10.jpg';
import avatar11 from '../../../assets/about/creators/11.jpg';
import avatar12 from '../../../assets/about/creators/12.jpg';
import avatar13 from '../../../assets/about/creators/13.jpg';
import avatar14 from '../../../assets/about/creators/14.jpg';
import avatar15 from '../../../assets/about/creators/15.jpg';
import avatar16 from '../../../assets/about/creators/16.jpg';
import avatar17 from '../../../assets/about/creators/17.jpg';
import avatar18 from '../../../assets/about/creators/18.jpg';
import avatar19 from '../../../assets/about/creators/19.jpg';
import avatar2 from '../../../assets/about/creators/2.jpg';
import avatar20 from '../../../assets/about/creators/20.jpg';
import avatar21 from '../../../assets/about/creators/21.jpg';
import avatar22 from '../../../assets/about/creators/22.jpg';
import avatar23 from '../../../assets/about/creators/23.jpg';
import avatar24 from '../../../assets/about/creators/24.jpg';
import avatar25 from '../../../assets/about/creators/25.jpg';
import avatar26 from '../../../assets/about/creators/26.jpg';
import avatar27 from '../../../assets/about/creators/27.jpg';
import avatar28 from '../../../assets/about/creators/28.jpg';
import avatar3 from '../../../assets/about/creators/3.jpg';
import avatar4 from '../../../assets/about/creators/4.jpg';
import avatar5 from '../../../assets/about/creators/5.jpg';
import avatar6 from '../../../assets/about/creators/6.jpg';
import avatar7 from '../../../assets/about/creators/7.jpg';
import avatar8 from '../../../assets/about/creators/8.jpg';
import avatar9 from '../../../assets/about/creators/9.jpg';

export const ABOUT_CREATORS = [
  {
    image: avatar3,
    name: 'ZBIGNIEW WOZNOWSKI',
    position: 'CEO',
    link: 'https://www.linkedin.com/in/zwoznowski/',
  },
  {
    image: avatar2,
    name: 'PIOTR JANIUK',
    position: 'Technology partner',
    link: 'https://www.linkedin.com/in/viggith/',
  },
  {
    image: avatar5,
    name: 'MACIEJ BURNO',
    position: 'CBDO',
    link: 'https://www.linkedin.com/in/maciejburno/',
  },
  {
    image: avatar4,
    name: 'MICHAEL LAGODZIC',
    position: 'COO',
    link: 'https://www.linkedin.com/in/michal-lagodzic/',
  },
  {
    image: avatar8,
    name: 'RADEK ZAGOROWICZ',
    position: 'Technology partner',
    link: 'https://www.linkedin.com/in/radoslaw-zagorowicz/',
  },
  {
    image: avatar1,
    name: 'MIROSLAW SKOWRONSKI',
    position: 'CTO',
    link: 'https://www.linkedin.com/in/miros%C5%82aw-skowro%C5%84ski-551664119/',
  },
  {
    image: avatar13,
    name: 'Artur Pszczolkowski',
    position: 'GamerHash CMO/VP / Advisor',
    link: 'https://www.linkedin.com/in/arturpszczolkowski/',
  },
  {
    image: avatar7,
    name: 'Adam Jarmicki',
    position: 'Advisor',
    link: 'https://www.linkedin.com/in/adamjarmicki/',
  },
  {
    image: avatar14,
    name: 'Igor Wos',
    position: 'Advisor / Founder of Neat',
    link: 'https://www.linkedin.com/in/igorwos/',
  },
  {
    image: avatar6,
    name: 'Marius Gasiewski',
    position: 'Early Investor / Advisor',
    link: 'https://www.linkedin.com/in/mariuszgasiewski/',
  },
  {
    image: avatar12,
    name: 'Paul Burghardt',
    position: 'Technical Advisor / Golem CPO',
    link: 'https://www.linkedin.com/in/pawe%C5%82-burgchardt-43406465/',
  },
  {
    image: avatar27,
    name: 'Wojciech Lugowski',
    position: 'Legals / Advisor',
    link: 'https://www.linkedin.com/in/wojciech-lugowski/',
  },
  {
    image: avatar11,
    name: 'Nav Sunner',
    position: 'CEO and Founder of Navatron / Advisor',
    link: 'https://www.linkedin.com/in/nav-sunner-508779/',
  },
  {
    image: avatar10,
    name: 'Filippos Drogitis',
    position: 'Head of community',
    link: 'https://www.linkedin.com/in/filippostheodorakopoulosdrogitis/',
  },
  {
    image: avatar9,
    name: 'Adam Smolarczyk',
    position: 'Head of analytics',
    link: 'https://www.linkedin.com/in/smolarczykadam/',
  },
  {
    image: avatar15,
    name: 'Stanislav Poleheshko',
    position: 'Social media specialist',
    link: 'https://www.linkedin.com/in/stanislav-poleheshko-5a9a76236/',
  },
  {
    image: avatar16,
    name: 'Mirheydar Badirov',
    position: 'Social media specialist',
    link: 'https://www.linkedin.com/in/mbadirov/',
  },
  {
    image: avatar17,
    name: 'Carolina Gurgul',
    position: 'Social media specialist',
    link: 'https://www.linkedin.com/in/karolina-gurgul-3032aa241/',
  },
  {
    image: avatar18,
    name: 'Martha Byrne',
    position: 'Process & product manager',
    link: 'https://www.linkedin.com/in/marta-byrne-b7664115b/',
  },
  {
    image: avatar19,
    name: 'Sieciech Czajka',
    position: 'Senior software engineer',
    link: 'https://www.linkedin.com/in/sieciech-czajka/',
  },
  {
    image: avatar20,
    name: 'Thomas Partyka',
    position: 'Crypto analyst',
    link: null,
  },
  {
    image: avatar21,
    name: 'Peter Gorny',
    position: 'NFT Manager / Railway architect',
    link: 'https://www.linkedin.com/in/piogorny/',
  },
  {
    image: avatar22,
    name: 'Martina Jeute',
    position: 'Business manager',
    link: 'https://www.linkedin.com/in/martyna-jeute/',
  },
  {
    image: avatar23,
    name: 'Annette Dziewonska',
    position: 'Senior motion designer',
    link: 'https://www.linkedin.com/in/aneta-dziewo%C5%84ska-72878b11b/',
  },
  {
    image: avatar24,
    name: 'Ksenia Shinkariuk',
    position: 'Senior motion designer',
    link: 'https://www.linkedin.com/in/shynik/',
  },
  {
    image: avatar25,
    name: 'Andrii Bauer',
    position: 'Senior motion designer',
    link: 'https://www.linkedin.com/in/andriibauer/',
  },
  {
    image: avatar26,
    name: 'Martin Benke',
    position: 'R & D advisor',
    link: 'https://www.linkedin.com/in/marcin-benke-0a8263/',
  },
  {
    image: avatar28,
    name: 'Farjmand Zara',
    position: 'Blockchain developer',
    link: 'https://www.linkedin.com/in/farjmand-zara/',
  },
];
